import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  Tooltip,
} from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import React, { useState } from 'react'
import { useFormik } from 'formik'
import { UserWithBusiness } from '@marketing-milk/interfaces'
import { toast } from 'react-toastify'
import axios from 'axios'
import Connect from 'app/redux/connect'
import { Connected } from '../../../../app/interface/redux'
import { BusinessSelection } from '../shared/BusinessSelection'
import { NestAPI } from '../../../../app/nestapi'

type AssignBusinessesProps = {
  mmUser: UserWithBusiness
  onSave: () => void
}

const AssignBusinesses = ({ mmUser, onSave, ...props }: AssignBusinessesProps & Connected) => {
  const [open, setOpen] = useState(false)
  const businesses = props.data.generic.businesses.data
  const assignedBusinessIds = new Set((mmUser.businesses || []).map(b => b.id))
  const availableBusinesses = businesses.filter(b => !assignedBusinessIds.has(b.id))

  const handleClose = () => {
    formik.resetForm()
    setOpen(false)
  }

  const formik = useFormik({
    initialValues: {
      businesses: [] as number[],
      receiveLeads: false,
      receiveStatus: false,
    },
    // validationSchema: validationSchema,
    onSubmit: async values => {
      const businesses = values.businesses

      setOpen(false)

      try {
        //TODO: we have two userService files: one in admin and one in frontend. Put this in frontend.
        await NestAPI.put(`users/${mmUser.id}/businesses`, {
          businesses,
          receiveLeads: values.receiveLeads,
          receiveStatus: values.receiveStatus,
        })

        toast.success('Updated user businesses')
        onSave()
      } catch (e) {
        if (axios.isAxiosError(e) && e.response?.data) {
          e.response.data.errors.forEach(err => {
            toast.error(err.description)
          })
        } else {
          toast.error(`We could not update the user's businesses at this time`)
        }
      }
    },
  })

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        <span>Assign Businesses</span>
      </Button>

      <Dialog
        fullWidth
        maxWidth={'sm'}
        open={open}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">Assign Businesses</DialogTitle>
        <form className="form" noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
          <DialogContent>
            <BusinessSelection
              businesses={availableBusinesses}
              selectedIds={formik.values.businesses}
              onChange={ids => formik.setFieldValue('businesses', ids)}
            />
            <div
              className="pt-2"
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <span>Receive Leads:</span>
              <Switch
                onChange={value =>
                  formik.setFieldValue('receiveLeads', !formik.values.receiveLeads)
                }
                checked={formik.values.receiveLeads}
              />
            </div>
            <div
              className="pt-2"
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <span>
                Receive Status:
                <Tooltip
                  title={
                    <span style={{ fontSize: '14px' }}>
                      This is for general status updates about the account, like reminders for
                      uploads
                    </span>
                  }
                  arrow
                  placement="top"
                >
                  <InfoIcon
                    fontSize="small"
                    style={{ marginLeft: 4, color: '#a044ff', cursor: 'pointer' }}
                  />
                </Tooltip>
              </span>
              <Switch
                onChange={value =>
                  formik.setFieldValue('receiveStatus', !formik.values.receiveStatus)
                }
                checked={formik.values.receiveStatus}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button type="submit" color="primary" disabled={formik.values.businesses.length === 0}>
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}

export default Connect(AssignBusinesses)
